import './App.css';
import { Router, Route } from 'react-router-dom';
import Home from './Pages/Home';
import ProductDetails from './Pages/ProductDetails';
import Cart from './Pages/Cart';
import Signup from './Pages/Signup';
import { CartContext } from './ContextAPI';
import { useState } from 'react';
import { history } from './faro';

export default function App() {
  
  const [cartItems, setCartItems] = useState([]);
  const handleInc = (product) => {
    setCartItems((prevItems) => {
      const quantity = product.qty || 1;
      const existingItem = prevItems.find((item) => item.id === product.id);
      return existingItem
        ? prevItems.map((item) => item.id === product.id ? { ...item, qty: item.qty + quantity } : item)
        : [...prevItems, { ...product, qty: quantity }];
    });
  };

  const handleDec = (productId) => {
    setCartItems(prevItems => {
      const existingItem = prevItems.find(item => item.id === productId);
      
      if (!existingItem) return prevItems;
      
      if (existingItem.qty === 1) {
        return prevItems.filter(item => item.id !== productId);
      }
      
      return prevItems.map(item =>
        item.id === productId
          ? { ...item, qty: item.qty - 1 }
          : item
      );
    });
  };

  return (
    <CartContext.Provider value={{ cartItems, handleInc, handleDec }}>
      <Router history={history}>
        <Route path='/' component={Home} exact />
        <Route path='/product/:id' component={ProductDetails} exact />
        <Route path='/cart' component={Cart} exact />
        <Route path='/signup' component={Signup} exact />
      </Router>
    </CartContext.Provider>
  );
}
